export default "__VITE_ASSET__CbGCWxoY__"